module.exports = __webpack_public_path__ + "static/media/pause.0fbc8b83.svg";